<template>
    <div class="student-course-module-card">
        <div class="header">
            <img :src="moduleIn.file ? moduleIn.file.public_path : ''" :alt="`banner ${moduleIn.name}`">
            <div class="module-tools">
                <div class="optional-module"
                     :title="$t('slu_dashboard.optional_module')"
                     v-b-tooltip.hover
                     v-if="!moduleIn.required">
                    <i class="fad fa-fw fa-sparkles"></i>
                </div>

                <div class="selected-option course-module-status"
                     v-if="this.$authUser.isAdmin() || this.$authUser.isTeacher()">
                    <span class="tag-color" :style="{backgroundColor: `${sluRecord.color}` }"></span>
                    <div class="tag-name">{{ sluRecord.name }}</div>
                </div>

<!--                <b-form-group v-if="this.$authUser.isAdmin() || this.$authUser.isTeacher()">-->
<!--                    <design-2021-apprentice-multiselect-component-->
<!--                        class="status-select"-->
<!--                        :options="sluStatusTagsIn"-->
<!--                        label="name"-->
<!--                        :show-labels="false"-->
<!--                        v-model="sluRecord"-->
<!--                        :multiple-select="false"-->
<!--                        track-by="id"-->
<!--                        @input="updateStudentModuleStatus(sluRecord)"-->
<!--                        :disabled="true">-->
<!--                        <template slot="singleLabel" slot-scope="props">-->
<!--                            <div class="selected-option">-->
<!--                                <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
<!--                                <div class="tag-name">{{ props.option.name }}</div>-->
<!--                            </div>-->
<!--                        </template>-->

<!--                        <template slot="option" slot-scope="props">-->
<!--                            <div class="tag-option">-->
<!--                                <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
<!--                                <div class="tag-name">{{ props.option.name }}</div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </design-2021-apprentice-multiselect-component>-->
<!--                </b-form-group>-->
            </div>
        </div>
        <div class="body">
            <div class="title">
                {{ moduleIn.name }}
            </div>
            <div class="labels"
                 v-if="moduleIn.slu_labels.length > 0 && !$authUser.isStudent()">
                <b-badge pill
                         v-for="label in moduleIn.slu_labels"
                         :key="label.id"
                         :style="{backgroundColor: label.color}">
                    {{ label.name}}
                </b-badge>
            </div>
            <div class="description">
                <design-2021-apprentice-display-html-component
                    :html-content="moduleIn.description | editor_text_preview(25)">
                </design-2021-apprentice-display-html-component>
            </div>
            <div class="show-more">
                <span class="points">
                    <i class="btn-clock-one-thirty icon"></i>{{ moduleIn.hours }}
                </span>

                <span class="school-points" v-if="sluSchoolSettingsIn.hours_to_point">
                   {{ moduleIn.hours / sluSchoolSettingsIn.hours_to_point }}<span class="name-points">{{sluSchoolSettingsIn.name_points}}</span>
                </span>

                <!--                    v-if="this.$authUser.isStudent()"-->
                <b-badge class="student-module-status"
                         pill
                         variant="info"
                         :style="cssVars">
                    {{ record.name }}
                </b-badge>
            </div>
        </div>
        <a @click.prevent.stop="openModal" class="clickable"></a>
    </div>
</template>

<script>
export default {
    name: "design-2021-slu-student-course-module-card-component",
    props: {
        moduleIn: {
            type: Object,
            required: true,
        },
        sluStatusTagsIn: {
            type: Array,
            required: false,
        },
        sluRecordIn: {
            type: Object,
            required: true,
        },
        sluSchoolSettingsIn: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            sluRecord: this.sluRecordIn,
        }
    },

    computed: {
        record() {
            return typeof this.sluRecordIn !== 'undefined' ? this.sluRecordIn : this.sluStatusTagsIn.find((option) => option.id === null);
        },

        cssVars(){
            return {
                '--student-status-bgcolor': this.record.color,
            }
        },
    },

    methods: {
        openModal() {
            this.$emit('open-modal', this.moduleIn);
        },

        updateStudentModuleStatus(status) {
            this.$emit('update-status', this.moduleIn, status);
        },
    },

    watch: {
        sluRecordIn: function(val){
            this.sluRecord = val;
        }
    }
}
</script>

<style scoped lang="scss">
    .selected-option,
    .tag-option,
    .course-module-status {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        column-gap: 8px;

        .tag-color {
            display: inline-block;
            width: 13px;
            height: 13px;
            border-radius: 50%;
        }
    }

    .course-module-status {
        position:relative;
        padding: 8px 16px;
        border-radius: $border-radius-content;

        .tag-name,
        .tag-color {
            z-index: 45;
            font-weight: $font-weight-medium;
        }

        &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: $secondary-background-color;
            left: 0;
            border-radius: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .student-course-module-card {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        height: 100%;
        border: 1px solid $border-color;
        border-radius: $border-radius-content;

        .header {
            height: 125px;
            width: 100%;
            position: relative;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
                border-top-left-radius: $border-radius-content;
                border-top-right-radius: $border-radius-content;
            }

            .module-tools {
                position: absolute;
                top: 10px;
                right: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                column-gap: map-get($grid-gutter-spacing, 'fifteen');
                z-index: 10;
            }

            .optional-module {
                height: 41px;
                padding: map-get($grid-gutter-spacing, 'ten');
                background-color: $primary;
                color: $white;
                border-radius: 8px;
            }

            fieldset {
                margin-bottom: 0;
                width: 150px;
            }

            .status-select ::v-deep {
                .multiselect__tags {
                    padding-top: map-get($grid-gutter-spacing, 'ten');
                    padding-bottom: map-get($grid-gutter-spacing, 'ten');
                }

                .multiselect__single,
                .multiselect__option,
                input {
                    font-size: $default-font-size;
                }
            }
        }

        &:hover {
            cursor: pointer;
            border-bottom-left-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
            box-shadow: 0 3px 21px 0 rgb(0 0 0 / 10%), 0 1px 8px 0 rgb(0 0 0 / 5%);
        }
    }

    .body {
        padding: map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'fifteen');
        height: calc(100% - 125px);
        display: flex;
        flex: 1 0 100%;
        flex-direction: column;


        .title {
            font-weight: $font-weight-medium;
            font-size: 1.3125rem;
            margin-bottom: map-get($grid-gutter-spacing, 'eigh');
        }

        .labels {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            column-gap: map-get($grid-gutter-spacing, 'ten');
            row-gap: map-get($grid-gutter-spacing, 'ten');
            margin-bottom: map-get($grid-gutter-spacing, 'eight');

            .badge {
                color: $white;
                font-size: 0.75rem;
                font-weight: $font-weight-medium;
                padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');
            }
        }

        .description {
            color: $text-muted-color;
            font-weight: $font-weight-medium;
            line-height: 1.3;
            margin-top: auto;
            margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
        }

        .show-more {
            flex-wrap: wrap;
            column-gap: $grid-gutter-width;
            font-weight: $font-weight-bold;
            margin-top: auto;
            justify-content: space-between;

            &,
            .points {
                display: flex;
                flex-direction: row;

                align-items: center;
            }

            .points,
            .school-points {
                font-size: $base-font-size;

                .icon {
                    font-style: normal;
                    font-weight: $font-weight-normal;
                    color: $orange;
                    margin-right: map-get($grid-gutter-spacing, 'eight');

                    &:before {
                        margin-right: 0;
                    }
                }

                .name-points {
                    color: $orange;
                    font-size: 0.75rem;
                    margin-left: map-get($grid-gutter-spacing, 'eight');
                }
            }

            .status {
                font-size: 0.75rem;
                padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');
            }

            .student-module-status {
                background-color: var(--student-status-bgcolor);
                //margin-left: auto;
                font-size: 0.75rem;
                padding: 4px 8px;
            }

            .more-text {
                margin-left: auto;
            }
        }
    }

</style>
